import React from 'react';
import PropTypes from 'prop-types';
import ReactPhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css';
import Input from "../input/Input";
import clsx from "clsx";

export const PhoneInput = React.forwardRef((props, ref) => {

  const {
    placeholder,
    required,
    name,
    error,
    disabled = false,
    ...other
  } = props;

  return (
    <Input {...other} required={required} error={error}>
      <ReactPhoneInput
        {...other}
        disabled={disabled}
        required={required}
        name={name}
        containerClass={clsx({"is-invalid": error, 'disabled-phone': disabled})}
        ref={ref}
        placeholder={placeholder}
        inputProps={{name, required}}/>
    </Input>
  );
});

PhoneInput.defaultProps = {
  help: '',
  placeholder: '',
  className: '',
};

PhoneInput.propTypes = {
  label: PropTypes.string,
  placeholder: PropTypes.string,
  help: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.string,
};

export default PhoneInput;
